import { useEffect, useState } from 'react';
import Modal from '../Modal';
import { repositorioFazenda, repositorioTalhao } from '../../sync/repositories/fazendas';
import { extrairMensagensErro } from '../../utils/errorUtils';

const ESTADO_INICIAL = { nome_codigo: '', fazenda: '', hectares: '' };

/** Modal de cadastro rápido de Talhão. Busca a lista de fazendas sozinho ao abrir. */
export default function ModalCadastroTalhao({ isOpen, onClose, onSuccess, fazendaSelecionadaId = null }) {
  const [dados, setDados] = useState(ESTADO_INICIAL);
  const [fazendas, setFazendas] = useState([]);
  const [salvando, setSalvando] = useState(false);
  const [erros, setErros] = useState([]);

  useEffect(() => {
    if (!isOpen) {
      setDados(ESTADO_INICIAL);
      setErros([]);
      setSalvando(false);
      return;
    }
    repositorioFazenda.listar()
      .then((resp) => setFazendas(Array.isArray(resp.data) ? resp.data : (resp.data.results || [])))
      .catch(() => setFazendas([]));
    setDados((prev) => ({ ...prev, fazenda: fazendaSelecionadaId || '' }));
  }, [isOpen, fazendaSelecionadaId]);

  const handleChange = (campo) => (e) => setDados((prev) => ({ ...prev, [campo]: e.target.value }));

  const handleSalvar = async (e) => {
    e?.preventDefault?.();
    if (!dados.nome_codigo.trim()) { setErros(['O nome/código é obrigatório.']); return; }
    if (!dados.fazenda) { setErros(['Selecione a fazenda.']); return; }
    if (!dados.hectares) { setErros(['Informe a área em hectares.']); return; }
    setSalvando(true);
    setErros([]);
    try {
      const resp = await repositorioTalhao.criar({
        nome_codigo: dados.nome_codigo.trim(),
        fazenda: dados.fazenda,
        hectares: Number(dados.hectares),
      });
      onSuccess?.(resp.data);
      onClose?.();
    } catch (error) {
      setErros(extrairMensagensErro(error));
    } finally {
      setSalvando(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={salvando ? () => {} : onClose} title="Cadastrar Talhão">
      <form onSubmit={handleSalvar} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Nome / Código *</label>
          <input
            type="text"
            value={dados.nome_codigo}
            onChange={handleChange('nome_codigo')}
            className="w-full border border-gray-300 p-2 rounded focus:ring-2 focus:ring-green-300"
            placeholder="Ex: Talhão A, Norte 01..."
            autoFocus
            disabled={salvando}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Fazenda *</label>
          <select
            value={dados.fazenda}
            onChange={handleChange('fazenda')}
            disabled={salvando}
            className="w-full border border-gray-300 p-2 rounded focus:ring-2 focus:ring-green-300 bg-white"
          >
            <option value="">Selecione...</option>
            {fazendas.map((f) => <option key={f.id} value={f.id}>{f.nome}</option>)}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Área (hectares) *</label>
          <input
            type="number" step="0.01" min="0.01"
            value={dados.hectares}
            onChange={handleChange('hectares')}
            className="w-full border border-gray-300 p-2 rounded focus:ring-2 focus:ring-green-300"
            disabled={salvando}
          />
        </div>
        {erros.length > 0 && (
          <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded p-3 space-y-1">
            {erros.map((m, i) => <div key={i}>{m}</div>)}
          </div>
        )}
        <div className="flex justify-end gap-2 pt-2">
          <button type="button" onClick={onClose} disabled={salvando}
            className="px-4 py-2 rounded border border-gray-300 text-gray-700 hover:bg-gray-100 disabled:opacity-50">
            Cancelar
          </button>
          <button type="submit" disabled={salvando}
            className="px-4 py-2 rounded bg-blue-600 hover:bg-blue-700 text-white disabled:bg-blue-300">
            {salvando ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
